module.exports = __webpack_public_path__ + "img/g4.d1219ecf.png";